import React__default from 'react';
import Radio from '../../../../../../node_modules/@mui/material/Radio/Radio.mjs';
import styled from '../../../../../../node_modules/@mui/material/styles/styled.mjs';
import FormControlLabel from '../../../../../../node_modules/@mui/material/FormControlLabel/FormControlLabel.mjs';
import radioClasses from '../../../../../../node_modules/@mui/material/Radio/radioClasses.mjs';

const StyledFormControlLabel = styled(FormControlLabel)(({ theme })=>({
        marginLeft: theme.spacing(-0.25),
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        gap: theme.spacing(0.5),
        [`&:hover, &.${radioClasses.checked}:hover`]: {
            backgroundColor: 'transparent'
        }
    }));
const RadioCore = ({ autoFocus, checked, className, disabled, label, onClick, value })=>{
    const handleChange = (e)=>{
        onClick?.(e.target.value);
    };
    return /*#__PURE__*/ React__default.createElement(StyledFormControlLabel, {
        className: className,
        control: /*#__PURE__*/ React__default.createElement(Radio, {
            autoFocus: autoFocus,
            checked: checked,
            onChange: handleChange,
            size: "small",
            value: value
        }),
        disabled: disabled,
        label: label
    });
};

export { RadioCore };
//# sourceMappingURL=Radio.mjs.map
